<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Control de Dictámenes</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" style="background-color:#bebebc">
            <div class="row">
              <div class="col-2">
                <input class="form-control" style="background-color:var(--verde-pj-100); color: var(--blanco-pj)" type="button" value="Nuevo Dictamen" @click="irNuevoDictamen" />
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3 font-black">
                <h5>Estatus :</h5>
              </div>
              <div class="col-3 font-black">
                <h5>Psicólogo :</h5>
              </div>

              <div class="col-3 font-black">
                <h5>No. de Expediente :</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <C004EstatusDeDictamen v-on:valorParaElPadre="cambioEstatusDeDictamen"
                                       :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                       :tipo="enumeraciones.tiposDeSelect.Todos"
                                       :idDelInput="'catalogoEstatusDeDictamen'"
                                       :parametros="parametros_EstatusDeDictamen"
                                       :valorDefinido="parametros_EstatusDeDictamen.ValorDefinido">
                </C004EstatusDeDictamen>
              </div>
              <div class="col-3">
                <C003Psicologos v-on:valorParaElPadre="cambioPsicologo"
                                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                :tipo="enumeraciones.tiposDeSelect.Todos"
                                :idDelInput="'catalogoPsicologo'"
                                :parametros="parametros_Psicologo"
                                :valorDefinido="parametros_Psicologo.ValorDefinido">
                </C003Psicologos>
              </div>
              <div class="col-3">
                <input type="text" class="form-control campos" placeholder="####/####" v-model="numeroExpediente" />
              </div>
              <div class="col-3">
                <input type="button" value="Buscar" class="form-control" style="background-color:var(--verde-pj-100); color: var(--blanco-pj)" @click="buscarDictamenes" />
              </div>
            </div>
            <div class="row new-row">
              <table class="table table-striped table-light table-hover"
                     id="tablaDictamenes">
                <thead style="background-color:#004746">
                  <tr>
                    <th>
                      No. Folio
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(0,true)' title="Ordenar por No. Folio" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(0,false)' title="Ordenar por No. Folio" /></div>
                    </th>
                    <th>
                      No. Expediente
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(1,true)' title="Ordenar por No. Expediente" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(1,false)' title="Ordenar por No. Expediente" /></div>
                    </th>
                    <th>
                      Psicólogo
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(2,true)' title="Ordenar por Psicólogo" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(2,false)' title="Ordenar por Psicólogo" /></div>
                    </th>
                    <th>
                      Fecha Límite de Entrega
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(3,true)' title="Ordenar por Fecha Límite de Entrega" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(3,false)' title="Ordenar por Fecha Límite de Entrega" /></div>
                    </th>
                    <th>
                      Estatus 
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(4,true)' title="Ordenar por Estatus" /></div>
                      <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(4,false)' title="Ordenar por Estatus" /></div>
                    </th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="dictamen in dictamenes" v-bind:key="dictamen.DictamenId">
                    <td>{{dictamen.DictamenId}}</td>
                    <td>{{dictamen.Expediente.Consecutivo}}</td>
                    <td v-if="dictamen.PsicologoId != null">{{dictamen.Psicologo.CuentaUsuario.Nombre}} {{dictamen.Psicologo.CuentaUsuario.ApellidoPaterno}} {{dictamen.Psicologo.CuentaUsuario.ApellidoMaterno}}</td>
                    <td v-else>Sin Asignar</td>
                    <td>{{dictamen.FechaLimiteContestacionString}}</td>
                    <td>{{dictamen.EstatusDeDictamen.Nombre}}</td>
                    <td>
                      <i class="fas fa-user-plus fa-lg" @click="mostrarModalAsignarPsicologo(dictamen.DictamenId)" title="Asignar Psicólogo" v-if="dictamen.EstatusDeDictamen != 'Terminado' || dictamen.EstatusDeDictamen != 'Cancelado'" />
                      <!--<i class="fas fa-edit fa-lg" @click="" title="Editar Dictámen" />-->
                      <i class="fas fa-pause fa-lg" @click="validarDetenerDictamen(dictamen.DictamenId)" title="Detener Dictamen" 
                      v-if="dictamen.EstatusDeDictamen.Nombre === 'Creado' || dictamen.EstatusDeDictamen.Nombre === 'Asignado' || dictamen.EstatusDeDictamen.Nombre === 'En Proceso'"/>
                      <i class="fas fa-play fa-lg" @click="validarDetenerDictamen(dictamen.DictamenId)" title="Reanudar Dictamen" v-if="dictamen.EstatusDeDictamen.Nombre === 'Detenido'"/>
                      <i class="fas fa-ban fa-lg" @click="desactivarDictamen(dictamen.DictamenId)" title="Desactivar Dictamen" />
                      <i class="fas fa-file fa-lg" @click="mostrarModalVerDocumentoDictamen(dictamen.DictamenId)" title="Mostrar Documento de Dictamen" v-if="dictamen.EstatusDeDictamen.Nombre === 'Terminado'"/>
                    </td>
                  </tr>
                  <tr v-if="dictamenes.length == 0"><td colspan="6">No se encontraron dictamenes en la búsqueda.</td></tr>
                </tbody>
              </table>
            </div>
            <div><VerDocumentoDictamen :parametros="parametros_VerDocumentoDictamen" :key="parametros_VerDocumentoDictamen.dictamenId" /></div>
            <div class="modal fade"
                 id="modalAsignarPsicologo"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Asignar Psicólogo</h5>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <br />
                    <div class="row">
                      <div class="col-8">
                        <h5>Psicólogo:</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <C003PsicologosAsignar v-on:valorParaElPadre="cambioPsicologoAsignar"
                                               :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                               :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                               :idDelInput="'catalogoPsicologoAsignar'"
                                               :parametros="parametros_PsicologoAsignar"
                                               :valorDefinido="parametros_PsicologoAsignar.ValorDefinido">
                        </C003PsicologosAsignar>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary"
                            data-dismiss="modal"
                            @click="asignarPsicologo" :disabled="parametros_PsicologoAsignar.PsicologoId == -1">
                      Aceptar
                    </button>
                    <button type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import CalendarioDeCitas from '@/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue'
  import VerDocumentoDictamen from '@/components/SIPSIC/Dictamenes/ControlDeDictamenes/VerDocumentoDictamen.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        dictamenes: [],
        NumeroFilasPagina: 10,
        parametros_EstatusDeDictamen: {
          ValorDefinido: 1,
          EstatusDictamenId: 1,
          ConInactivos: false,
          EsDirector: true
        },
        parametros_Psicologo: {
          ValorDefinido: 0,
          PsicologoId: 0,
          ConInactivos: false
        },
        parametros_PsicologoAsignar: {
          ValorDefinido: -1,
          PsicologoId: -1,
          ConInactivos: false
        },
        parametros_VerDocumentoDictamen: {
          dictamenId: 0,
          key: 0
        },
        numeroExpediente: "",
        dictamenId: 0,
        columna: 0,
        sentido: true
      }
    },
    components: {
      C004EstatusDeDictamen: catalogos.SIPSIC.C004EstatusDeDictamen,
      C003Psicologos: catalogos.SIPSIC.C003Psicologos,
      C003PsicologosAsignar: catalogos.SIPSIC.C003Psicologos,
      CalendarioDeCitas,
      VerDocumentoDictamen
    },
    methods: {
      irNuevoDictamen: function () {
        this.$router.push({
          name: "NuevoDictamen"
        });
      },
      buscarDictamenes: function () {
        console.log('buscando')
        var peticion = {
          "esPrueba": false,
          "EstatusId": this.parametros_EstatusDeDictamen.EstatusDictamenId,
          "PsicologoId": this.parametros_Psicologo.PsicologoId,
          "JuzgadoId": 0,
          "NumExpediente": this.numeroExpediente
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetDictamenes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.dictamenes = response.data.Dictamenes

            this.$nextTick(() => {
              PaginarTabla('tablaDictamenes', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      asignarPsicologo: function () {
        var peticion = {
          "esPrueba": false,
          "DictamenId": this.dictamenId,
          "PsicologoId": this.parametros_PsicologoAsignar.PsicologoId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.AsignarPsicologo, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.buscarDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      desactivarDictamen: function (dictamenId) {
        var peticion = {
          "esPrueba": false,
          "DictamenId": dictamenId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.DesactivarDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.buscarDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      validarDetenerDictamen: function(dictamenId){
        bootbox.dialog({
                  title: 'Mensaje del sistema',
                  message: '¿Seguro que desea detener el dictamen?',
                  size: 'medium',
                  buttons: {
                    aceptar: {
                      label: "Aceptar",
                      className: 'btn btn-primary',
                      callback: () => {
                        this.detenerDictamen(dictamenId);
                      }
                    },
                    cancelar: {
                      label: "Cancelar",
                      className: 'btn btn-primary',
                      callback: () => {
                      }
                    }
                  }
                });
      },
      detenerDictamen: function(dictamenId){
        const peticion = {
          "esPrueba": false,
          "DictamenId": dictamenId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.DetenerDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.buscarDictamenes();
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      ordenar: function (columna, sentido) {
        this.columna = columna;
        this.sentido = sentido;
        this.dictamenes.sort(this.comparar);
        this.$nextTick(() => {
              PaginarTabla('tablaDictamenes', 10)
            })
      },comparar: function (a, b) {
        var filaA = 0;
        var filaB = 0;
        if (this.columna == 0) {
          filaA = a.DictamenId;
          filaB = b.DictamenId;
        }
        else if(this.columna === 1){
          filaA = a.Expediente.Consecutivo;
          filaB = b.Expediente.Consecutivo;
        }
        else if(this.columna === 2){
          filaA = (a.PsicologoId) ? `${a.Psicologo.CuentaUsuario.Nombre} ${a.Psicologo.CuentaUsuario.ApellidoPaterno} ${a.Psicologo.CuentaUsuario.ApellidoMaterno}` : "Sin Asignar";
          filaB = (b.PsicologoId) ? `${b.Psicologo.CuentaUsuario.Nombre} ${b.Psicologo.CuentaUsuario.ApellidoPaterno} ${b.Psicologo.CuentaUsuario.ApellidoMaterno}` : "Sin Asignar";
        } 
        else if(this.columna === 3){
          const from = a.FechaLimiteContestacionString.split("/");
          filaA = new Date(from[2], from[1] - 1, from[0]);
          const to = b.FechaLimiteContestacionString.split("/");
          filaB = new Date(to[2], to[1] - 1, to[0]);
        }
        else if (this.columna === 4) {
          filaA = a.EstatusDictamenId;
          filaB = b.EstatusDictamenId;
        } else {
          return 0;
        }        
        let comparison = 0;
        if (filaA > filaB) {
          comparison = 1;
        } else if (filaA < filaB) {
          comparison = -1;
        }
        if(!this.sentido)
          comparison *= -1;        
        return comparison;
      },
      cambioEstatusDeDictamen(datos) { //Administra los cambios en el componente de Estatus De Dictamen
        catalogos
        //console.log(datos);
        this.parametros_EstatusDeDictamen.EstatusDictamenId = parseInt(datos[0].target.value);
      },
      cambioPsicologo(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_Psicologo.PsicologoId = parseInt(datos[0].target.value);
      },
      cambioPsicologoAsignar(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_PsicologoAsignar.PsicologoId = parseInt(datos[0].target.value);
      },
      obtenerFechaHora: function (datos) {
        console.log("sopas");
        console.log(datos);
      },
      mostrarModalAsignarPsicologo: function (dictamenId) {
        this.parametros_PsicologoAsignar.PsicologoId = -1;
        $('#catalogoPsicologoAsignar').val(-1);
        this.dictamenId = dictamenId
        $('#modalAsignarPsicologo').modal('toggle');
      },
      mostrarModalVerDocumentoDictamen: function (dictamenId) {
        this.parametros_VerDocumentoDictamen.dictamenId = dictamenId
        ++this.parametros_VerDocumentoDictamen.key;
        this.$nextTick(() => {
          $('#modalVerDocumentoDictamen').modal('toggle');
        })
      }

    }, computed: {
      
    }, mounted: function mounted() {
      this.buscarDictamenes();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas, .fa {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
  .campos{
  background-color: white;
  color: black;
  }
  .font-black{
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ControlDeDictamenes/ControlDeDictamenes.vue